import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs';
import { BackendResponse } from 'src/app/interfaces/response.interface';
import { SectorI } from 'src/app/interfaces/segment-sector.interface';
import { handleError } from 'src/app/tools/tools';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class SectorService {
  constructor(private readonly http: HttpClient) {}

  private readonly url = environment.url + 'sectors/';

  findAll(params?: HttpParams) {
    return this.http.get<BackendResponse>(this.url, { params }).pipe(
      catchError((e) => handleError(e)),
      map((data) => data.result as { entities: SectorI[]; count: number })
    );
  }

  update(id: string, data: Partial<SectorI>) {
    const direction = this.url + id;
    return this.http.put<BackendResponse>(direction, data).pipe(
      catchError((e) => handleError(e)),
      map((data) => data.result as SectorI)
    );
  }

  insert(data: SectorI | SectorI[]) {
    return this.http.post<BackendResponse>(this.url, data).pipe(
      catchError((e) => handleError(e)),
      map((data) => data.result as SectorI | SectorI[])
    );
  }
}
